import BalanceCard from '../../../../../components/BalanceCard/BalanceCard';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import { balanceCards } from '../constants';
import { Stack } from '@mui/material';

const TabContent = ({
  orders,
  iconColor,
  label
}) => {
  const cards = balanceCards(orders);
  return (
    <>
      <Stack>
        <h4>{label}</h4>
        <div className="order-statistics-container">
          {
            cards.map((item, index) => (
              <BalanceCard
                key={index}
                title={item.title}
                value={item.value}
                icon={MonetizationOnRoundedIcon}
                iconColor={iconColor}
                borderColor={iconColor}
              />
            ))
          }
        </div>
      </Stack>

    </>
  );
}


export default TabContent